/** Working name, injected at build time (VITE_APP_NAME) so the product can be renamed in one place. */
export const APP_NAME: string = __APP_NAME__;
